import React from 'react';

import Tabs from './tabs';
import TabContents from './tab-contents';

export default function InlineTextPanel(props) {
  if (props.onlyVisibleInEditMode && !props.inEditMode) {
    return null;
  }

  return (
    <div className='inline-text-panel'>
      { props.inEditMode && <Tabs {...props} /> }
      <TabContents {...props} />
    </div>
  );
}

InlineTextPanel.propTypes = {
  onlyVisibleInEditMode: React.PropTypes.bool.isRequired,
  inEditMode: React.PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ./src/ui/inline-text/inline-text-panel.jsx